import { ChangeEvent, FC, useEffect, useState } from "react";
import "./PersonalStats.css";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../hooks/ReduxHooks";
import { getOperatorStats } from "../../../redux/requests/AdminRequests";
import dayjs from "dayjs";
import { Link } from "react-router-dom";

interface IPersonalStatsProps {}

const PersonalStats: FC<IPersonalStatsProps> = () => {
  const params = useParams();
  const dispatch = useAppDispatch();

  const operatorStats = useAppSelector((state) => state.admin.operatorStats);
  const [fromDate, setFromDate] = useState<string | null>(null);
  const [toDate, setToDate] = useState<string | null>(null);

  useEffect(() => {
    if (params.id && fromDate && toDate) {
      dispatch(getOperatorStats(params.id, fromDate, toDate));
    } else if (params.id && fromDate) {
      dispatch(getOperatorStats(params.id, fromDate));
    } else if (params.id && toDate) {
      dispatch(getOperatorStats(params.id, undefined, toDate));
    } else if (params.id) {
      dispatch(getOperatorStats(params.id));
    }
  }, [params.id, fromDate, toDate]);

  const getFromDate = (event: ChangeEvent<HTMLInputElement>) => {
    setFromDate(event.target.value);
  };

  const getToDate = (event: ChangeEvent<HTMLInputElement>) => {
    setToDate(event.target.value);
  };

  return (
    <div className="stats-page">
      <div className="stats_container">
        <h1>Статистика {operatorStats.operator.name}</h1>

        <div className="filters">
          <input type="date" placeholder="С даты" onChange={getFromDate} />
          <input type="date" placeholder="По дату" onChange={getToDate} />
        </div>

        <div className="stats-cards">
          <div className="card">
            <h2>Принято заявок</h2>
            <div className="value">{operatorStats.acceptedCount}</div>
          </div>
          <div className="card">
            <h2>Завершено диалогов</h2>
            <div className="value">{operatorStats.closedCount}</div>
          </div>
          <div className="card">
            <h2>Средняя оценка</h2>
            <div className="value">
              {Math.round(operatorStats.avgMark * 100) / 100}
            </div>
          </div>
        </div>

        <div className="dialog-list">
          <h3>Завершённые диалоги</h3>
          {operatorStats.completedTickets.map((item, index) => {
            return (
              <Link
                to={`/admin/tickets/dialog/${item.id}`}
                style={{ textDecoration: "none" }}
              >
                <div
                  className="dialog-item"
                  key={index}
                  style={{ borderBottom: "1px solid var(--light-gray)" }}
                >
                  <div className="dialog-title">Диалог #{item.id}</div>
                  <div className="dialog-meta">
                    Дата: {dayjs(item.closedAt).format("YYYY-MM-DD")} | Оценка:{" "}
                    {item.mark} | Клиент: {item.user.name}
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default PersonalStats;
